function enableBodyLock() {
  const body = document.querySelector('body');
  body.classList.add('body--no-scroll');
}

function disableBodyLock() {
  const body = document.querySelector('body');
  body.classList.remove('body--no-scroll');
}

function enableLockModalSafari() {
  const body = document.querySelector('body');
  body.classList.add('body--subscription-modal-open');
}

function disableLockModalSafari() {
  const body = document.querySelector('body');
  body.classList.remove('body--subscription-modal-open');
}

export { enableBodyLock, disableBodyLock, enableLockModalSafari, disableLockModalSafari };
